<template>
  <div id="GuestSetting">
    <section>
      <div id="container-center">
        <h1 style class="title has-text-centered">ユーザー設定</h1>
        <div class="tab_area">
          <div class="tab_contents profileContents">
            <b-tabs v-model="activeTab" :animated="true"  position="is-centered">
              <b-tab-item label="ユーザー情報設定" icon="account-box">
                <div id="item-contens">
                  <div class="card-content margin-top">
                    <table>
                      <tr><th>ユーザーID</th><td>{{userInfo.id}}</td></tr>
                      <tr><th>ユーザー名<span class="require" /></th>
                        <td><input type="text" style="width: 150px" v-model="editUserInfo.lastName" placeholder="姓" class="user" name="ユーザー名(姓)" validate="required"/>
                            <input type="text" style="width: 150px" v-model="editUserInfo.firstName" placeholder="名" class="user" name="ユーザー名(名)" validate="required"/>
                        </td>
                      </tr>
                      <tr><th>ユーザー名（カナ）<span class="require" /></th>
                        <td><input type="text" style="width: 150px" v-model="editUserInfo.lastNameKana" placeholder="セイ" class="user" name="ユーザー名カナ(姓)" validate="required|kana"/>
                            <input type="text" style="width: 150px" v-model="editUserInfo.firstNameKana" placeholder="メイ" class="user" name="ユーザー名カナ(名)" validate="required|kana"/>
                        </td>
                      </tr>
                      <tr><th>メールアドレス<span class="require" /></th><td><input type="text" v-model="editUserInfo.mail" class="user" name="メールアドレス" validate="required|mail" maxlength="100"/></td></tr>
                      <tr><th>パスフレーズ認証</th><td><b-checkbox class="cstmCheckBox" v-model="editUserInfo.passphraseFlag">二段階認証を行う</b-checkbox></td></tr>
                      <template v-if="editUserInfo.passphraseFlag">
                        <tr>
                          <th>送信先(携帯番号)</th>
                          <td><input type="text" class="passInput" v-model="editUserInfo.passphraseSendNo" id="passphraseSendNo" name="送信先(携帯番号)" validate="numeric" maxlength="20"/><b-button class="passButton" @click="sendTestSMS">テスト送信</b-button></td>
                        </tr>
                        <tr>
                          <th>送信先(Eメールアドレス)</th>
                          <td><input type="text" class="passInput" v-model="editUserInfo.passphraseSendMail" id="passphraseSendMail" name="送信先(Eメールアドレス)" validate="mail" maxlength="256"/><b-button class="passButton" @click="sendTestMail">テスト送信</b-button></td>
                        </tr>
                      </template>
                    </table>
                    <b-button class="innerButton is-primary" @click="regist">更新</b-button>
                  </div>
                </div>
              </b-tab-item>
              <b-tab-item label="所属先情報設定" icon="mdi mdi-office-building">
                <div id="item-contens">
                  <div class="card-content margin-top">
                    <table>
                      <tr><th>医療機関名・企業名</th><td style="word-break:break-all;">{{userInfo.medicalInstitutionName}}</td></tr>
                      <tr><th>診療科名・部署名</th><td style="word-break:break-all;">{{userInfo.departmentName}}</td></tr>
                      <tr><th>郵便番号</th><td style="word-break:break-all;">{{userInfo.postcode}}</td></tr>
                      <tr><th>都道府県</th><td style="word-break:break-all;">{{userInfo.prefecture}}</td></tr>
                      <tr><th>市町村区</th><td style="word-break:break-all;">{{userInfo.city}}</td></tr>
                      <tr><th>住所（それ以降の住所）</th><td style="word-break:break-all;">{{userInfo.address}}</td></tr>
                      <tr><th>住所（建物名、部屋番号）</th><td style="word-break:break-all;">{{userInfo.building}} </td></tr>
                      <tr><th>連絡先</th><td style="word-break:break-all;">{{userInfo.phoneNumber}}</td></tr>
                      <tr v-if="isHospital"><th>連絡先公開</th><td><b-checkbox class="cstmCheckBox" v-model="agreedInfoDisclosure">転院先施設として住所、連絡先（電話番号・メールアドレス）を公開する</b-checkbox></td></tr>
                      <tr v-if="isHospital && agreedInfoDisclosure"><th>連絡先メールアドレス<span class="require" /></th><td><input type="text" v-model="mainMail" class="belongs" name="連絡先メールアドレス" validate="required|mail" maxlength="256"/></td></tr>
                    </table>
                    <b-button v-if="isHospital" class="innerButton is-primary" @click="registBelongs">更新</b-button>
                    <table>
                      <tr><th style="vertical-align: top;">登録済みユーザー</th>
                        <td><span v-for="(user, index) in belongsUsers" :key="index">{{user.name}}<br></span><b-button class="is-primary userAddButton" @click="addUser">ユーザー追加依頼</b-button></td>
                      </tr>
                    </table>
                    <!-- <div class="searchButton-area">
                      <b-button class="is-primary" @click="addUser">ユーザー追加依頼</b-button>
                    </div> -->
                  </div>
                </div>
              </b-tab-item>
              <b-tab-item label="パスワード変更" icon="key-change">
                <div id="item-contens">
                  <div class="card-content margin-top">
                    <table>
                      <tr><th>変更前パスワード<span class="require" /></th><td><input type="password" v-model="oldPassword" /></td></tr>
                      <tr><th>変更後パスワード<span class="require" /></th><td><input type="password" v-model="newPassword"/></td></tr>
                      <tr><th>変更後パスワード(確認)<span class="require" /></th><td><input type="password" v-model="newPasswordComf"/></td></tr>
                      <tr><th></th><td>※パスワードは8桁以上5文字以上の<br>&nbsp;&nbsp;&nbsp;&nbsp;異なる文字で入力してください。</td></tr>
                    </table>
                    <b-button class="innerButton is-primary" @click="changePassword">パスワード変更</b-button>
                  </div>
                </div>
              </b-tab-item>
            </b-tabs>
            <div>
              <b-button class="backbutton is-primary" @click="back">戻る</b-button>
            </div>
          </div>
        </div>
      </div>
    </section>
    <b-modal
      :active.sync="isComponentModalActive"
      has-modal-card
      trap-focus
      :destroy-on-hide="true"
      :can-cancel="['escape', 'x']"
      aria-role="dialog"
      aria-label="Example Modal"
      aria-modal>
      <div class="modal-card" style="width: 650px;">
        <header class="modal-card-head">
          <p class="modal-card-title">ユーザー追加依頼</p>
        </header>
        <section class="modal-card-body">
          <div id="item-contens">
            <div class="card-content margin-top">
              <table>
                <tr>
                  <th>メールアドレス<span class="require" /></th>
                  <td><input type="text" v-model="addUserInfo.mail" class="validate" name="メールアドレス" validate="required|mail" maxlength="100"/></td>
                </tr>
                <!--#68対応_20250422
                <tr>
                  <th>認証ワード<span class="require" /></th>
                  <td><input type="text" v-model="addUserInfo.authentication" class="validate" name="認証ワード" validate="required" minlength="4" maxlength="100"/></td>
                </tr>
                <tr><th></th><td>認証ワードは4文字以上で入力してください。
                </td></tr>
                -->
              </table>
                <!--#68対応_20250422
               <span class="authNotice">※認証ワードは登録ユーザーが申込みを行う際に、本人認証として使用します。<br>　追加依頼後、登録するユーザーに直接お伝えください。</span>
               -->
            </div>
          </div>
        </section>
        <footer class="modal-card-foot">
          <div style="margin:auto;">
            <b-button label="閉じる" @click="isComponentModalActive=false" />
            <b-button label="追加依頼" type="is-primary" @click="save"/>
          </div>
        </footer>
      </div>
    </b-modal>
  </div>
</template>
<script>
import {role} from "@/components/mock/base/const.js";

export default {
  name: "GuestSetting",
  methods: {
    sendTestSMS: function(){
        if(this.editUserInfo.passphraseSendNo != ""){
            var checkFields = [document.getElementById("passphraseSendNo")];
            var result = this.selfMadeValidation(checkFields)
            if(result.msg == ""){
                this.sendTest({
                    passphraseSendMail:"",
                    passphraseSendNo:this.editUserInfo.passphraseSendNo
                });
            } else {
                this.showErrorMessage(result.msg)
            }
        } else {
            this.showErrorMessage("送信先(携帯番号)を入力してください。")
        }
    },
    sendTestMail: function(){
        if(this.editUserInfo.passphraseSendMail != ""){
            var checkFields = [document.getElementById("passphraseSendMail")];
            var result = this.selfMadeValidation(checkFields)
            if(result.msg == ""){
                this.sendTest({
                passphraseSendMail:this.editUserInfo.passphraseSendMail,
                    passphraseSendNo:""
                });
            } else {
                this.showErrorMessage(result.msg)
            }
        } else {
            this.showErrorMessage("送信先(Eメールアドレス)を入力してください。")
        }
    },
    sendTest: function(param){
        this.isActive = false;
        try {
            this.$store.dispatch("sendTest", {
              token: this.userInfo.token,
              contactAddress: param.passphraseSendMail,
              contactPhoneNumber: param.passphraseSendNo
            }).then(result => {
                console.log(result);
                if(result != null && result.status === 200 ) {
                    this.showMessage("メッセージを送信しました。<br>指定した宛先にメッセージが届いていることを確認してください。") 
                } else {
                    this.showErrorMessage(result.message) 
                }
                this.isActive = true;
            }).catch(error => {
                console.log(error);
                this.showErrorMessage("予期しないエラーが発生しました。")
                this.isActive = true;
            });
        } catch(err){
            console.log(error);
            this.showErrorMessage("予期しないエラーが発生しました。")
            this.isActive = true;
        }
    },
    regist: function(){
      if(this.editUserInfo.passphraseFlag){
        var element1 = document.getElementById("passphraseSendNo")
        var element2 = document.getElementById("passphraseSendMail")
        element1.style["border-color"] = "";
        element2.style["border-color"] = "";
        // パスフレーズ送信先チェック
        if(this.editUserInfo.passphraseFlag){
          if(!this.editUserInfo.passphraseSendNo && !this.editUserInfo.passphraseSendMail){
            this.showErrorMessage("パスフレーズ送信先は必須項目です。")
            element1.style["border-color"] = "red";
            element2.style["border-color"] = "red";
            return
          }
        }
      }
      // バリデーションチェック
      var elements = document.getElementsByClassName("user")
      var result = this.selfMadeValidation(elements)
      var errMsg = result.msg
      if(result.isError){
        this.showErrorMessage(errMsg)
      }else if (errMsg != ""){
        this.showErrorMessage(errMsg)
      }else{
        let message = "パスフレーズ送信先が正しく入力されていない場合、ログインできなくなります。 <br>パスフレーズの送信先を変更した場合、必ずテスト送信を行ってください。";
        if(!this.editUserInfo.passphraseFlag){
            message = "二段階認証を行わない場合、なり済ましログインなどのセキュリティリスクが高くなります。<br>セキュリティリスクを再度ご確認の上、ご登録ください。";
        }
        this.$dialog.confirm({
          title: " ",
          message: message,
          confirmText:"OK",
          cancelText: "キャンセル",
          onConfirm: async() => {
            //API呼出し
            var excuteApi = this.setSettingUserInfoUpdatePOST;
            var successCallBack = this.setSettingUserInfoUpdatePOSTSuccess;
            var errorCallBack = this.setSettingUserInfoUpdatePOSTError;
            // WebAPI Call
            this.apiCall(excuteApi, successCallBack, errorCallBack);
          }
        });
      }
    },
    setSettingUserInfoUpdatePOST: function(client) {
      var obj = JSON.parse(JSON.stringify(this.editUserInfo));
      obj.id = this.userInfo.id
      return client.apis.externalSetting.setSettingUserInfoUpdatePOST({
        body:obj
      });
    },
    setSettingUserInfoUpdatePOSTSuccess: function(result) {
      // 成功メッセージ表示
      this.showSuccess(result);
      this.editUserInfo.lastName = result.obj.lastName
      this.editUserInfo.firstName = result.obj.firstName
      this.editUserInfo.lastNameKana = result.obj.lastNameKana
      this.editUserInfo.firstNameKana = result.obj.firstNameKana
      this.editUserInfo.mail = result.obj.mail
      this.editUserInfo.passphraseFlag = result.obj.passphraseFlag
      this.editUserInfo.passphraseSendNo = result.obj.passphraseSendNo
      this.editUserInfo.passphraseSendMail = result.obj.passphraseSendMail

      this.userInfo.lastName = this.editUserInfo.lastName
      this.userInfo.firstName = this.editUserInfo.firstName
      this.userInfo.lastNameKana = this.editUserInfo.lastNameKana
      this.userInfo.firstNameKana = this.editUserInfo.firstNameKana
      this.userInfo.mail = this.editUserInfo.mail
      this.userInfo.passphraseFlag = this.editUserInfo.passphraseFlag
      this.userInfo.passphraseSendNo = this.editUserInfo.passphraseSendNo
      this.userInfo.passphraseSendMail = this.editUserInfo.passphraseSendMail
      sessionStorage.setItem('userInfo', JSON.stringify(this.userInfo));
      this.$emit("profileChanged");
    },
    setSettingUserInfoUpdatePOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    registBelongs: function(){
      // バリデーションチェック
      var elements = document.getElementsByClassName("belongs")
      var result = this.selfMadeValidation(elements)
      var errMsg = result.msg
      if(result.isError){
        this.showErrorMessage(errMsg)
      }else if (errMsg != ""){
        this.showErrorMessage(errMsg)
      }else{
        //API呼出し
        var excuteApi = this.setSettingBelongsInfoUpdatePOST;
        var successCallBack = this.setSettingBelongsInfoUpdatePOSTSuccess;
        var errorCallBack = this.setSettingBelongsInfoUpdatePOSTError;
        // WebAPI Call
        this.apiCall(excuteApi, successCallBack, errorCallBack);
      }
    },
    setSettingBelongsInfoUpdatePOST: function(client) {
      return client.apis.externalSetting.setSettingBelongsInfoUpdatePOST({
        body:{
          id:this.userInfo.belongsId,
          agreedInfoDisclosure:this.agreedInfoDisclosure,
          mainMail:this.mainMail,
        }
      });
    },
    setSettingBelongsInfoUpdatePOSTSuccess: function(result) {
      // 成功メッセージ表示
      this.showSuccess(result);
      this.agreedInfoDisclosure = result.obj.agreedInfoDisclosure
      this.mainMail = result.obj.mainMail

      this.userInfo.agreedInfoDisclosure = this.agreedInfoDisclosure
      this.userInfo.mainMail = this.mainMail
      sessionStorage.setItem('userInfo', JSON.stringify(this.userInfo));
    },
    setSettingBelongsInfoUpdatePOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    changePassword: function(){
      //入力チェック
      if(this.oldPassword == ""){
        this.showErrorMessage("変更前パスワードを入力してください。");
        return;
      } else if(this.newPassword == "") {
        this.showErrorMessage("変更後パスワードを入力してください。");
        return;
      } else if(this.newPasswordComf == "") {
        this.showErrorMessage("変更後パスワード(確認)を入力してください。");
        return;
      } else if(this.oldPassword == this.newPassword){
        this.showErrorMessage("変更前と違うパスワードを入力してください。");
        return;
      }
      //newパスワードの形式チェック
      if(this.newPassword.length < 8){
        this.showErrorMessage("変更後パスワードは8文字以上で指定してください。");
        return;
      } else if(this.newPassword.length > 256){
        this.showErrorMessage("変更後パスワードは256文字以下で指定してください。");
        return;
      } else {
        var array1 = this.newPassword.split('');
        var array2 = Array.from(new Set(array1));
        if(array2.length < 5){
          this.showErrorMessage("変更後パスワードは5文字以上の異なる文字を使用してください。");
          return;
        }
      }
      //新パスワード一致確認
      if(this.newPassword != this.newPasswordComf){
        this.showErrorMessage("変更後パスワード(確認)が一致しません。");
        return;
      }
      //API呼出し
      var excuteApi = this.passwordChangePOST;
      var successCallBack = this.successPasswordChangePOST;
      var errorCallBack = this.errorPasswordChangePOST;
      // WebAPI Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);

    },
    passwordChangePOST: function(client){
      return client.apis.auth.passwordChangePOST({
        body: {
            currentpassword: this.oldPassword,
            newpassword: this.newPassword
        }
      });
    },
    successPasswordChangePOST: function(result){
      this.showSuccess(result);
      this.oldPassword = "";
      this.newPassword = "";
      this.newPasswordComf = "";
    },
    errorPasswordChangePOST: function(result){
      this.showErrorMessage(result);
    },
    back: function() {
      this.$router.go(-1);
    },
    doSearch: function() {
      // Web Api Call
      var _this = this;
      this.apiCall(
        function(client){
          return client.apis.internalMaintenance.getMaintenanceExternalUserListPOST({
            body:{
              userId:"",
              name:"",
              phoneNumber:"",
              mail:"",
              status:"",
              // belongsId:_this.belongsId
              belongsId:String(_this.belongsId)
            }
          });
        },
        function(result){
          _this.belongsUsers = result.obj
        },
        function(result){
          _this.showErrorMessage(result);
    }
      );
    },
    addUser: function() {
      this.addUserInfo = {mail:""};
      this.isComponentModalActive = true;
    },
    save: async function() {
      // バリデーションチェック
      var elements = document.getElementsByClassName("validate")
      var result = this.selfMadeValidation(elements)
      var errMsg = result.msg
      if(result.isError){
        this.showErrorMessage(errMsg)
        return
      } else if (errMsg != ""){
        this.showErrorMessage(errMsg)
      }else{
        // Web Api Call
        this.$store.dispatch("sendUserAddMailPOST", {
            mail:this.addUserInfo.mail,
            //authentication:this.addUserInfo.authentication,
            belongsId:this.belongsId,
            apiPath: "/userAddRegistForm"
        }).then(result => {
            if(result != null && result.status === 200 ) {
              this.showSuccess(result);
              this.isComponentModalActive = false
            } else if (result != null && (result.status === 400 || result.status === 401 || result.status === 500)){
              var message = "予期しないエラーが発生しました。"
              if(result.response && result.response.body && result.response.body.message){
                message = result.response.body.message
              } else if(result.message){
                message = result.message
              }
              this.showErrorMessage(message)
            } else {
              this.showErrorMessage("予期しないエラーが発生しました。")
            }
        });
      }
    },
  },
  data() {
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var roleId = userInfo.roleId;
    var isHospital = roleId == role.role_hospital;
    var isChangePassword = this.$route.params.passwordChange;
    var editUserInfo = {
      lastName:userInfo.lastName,
      firstName:userInfo.firstName,
      lastNameKana:userInfo.lastNameKana,
      firstNameKana:userInfo.firstNameKana,
      mail:userInfo.mail,
      passphraseFlag:userInfo.passphraseFlag,
      passphraseSendNo:userInfo.passphraseSendNo,
      passphraseSendMail:userInfo.passphraseSendMail
    }
    var activeTab = 0
    if(isChangePassword){
      activeTab = 2
    }
    return {
      role: role,
      isHospital,
      activeTab,
      userInfo: userInfo,
      editUserInfo,
      agreedInfoDisclosure:userInfo.agreedInfoDisclosure,
      mainMail:userInfo.mainMail,
      oldPassword:"",
      newPassword:"",
      newPasswordComf:"",
      isComponentModalActive:false,
      belongsId:userInfo.belongsId,
      belongsUsers:[],
      addUserInfo:{
        mail:"",
        //authentication:""
      },
    };
  },
  computed: {},
  mounted: function(){
    this.doSearch()
  }
};
</script>

<style>
</style>
<style lang="scss">
.tab_area {
  text-align: center;
}
.tab_contents {
  display: inline-block;
}
.innerButton{
  margin-top:10px;
}
.passInput {
  width: 200px !important;
}
.passButton {
  margin-left:5px;
  width:100px !important;
  height:29px !important;
}
.userAddButton {
  margin-top:10px;
  width:150px !important;
  height:29px !important;
}
.authNotice {
  margin-top:10px;
  color:red;
  font-size: 14px;
  display: inline-block;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/guest/GuestSetting.vue